import React from 'react';
import { useRecoilValue, useRecoilState } from 'recoil';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import classnames from 'classnames';
import * as cookiesManager from '../../utils/cookiesManager';
import * as appPropTypes from '../../components/appPropTypes';
import { withRoomContext } from '../../RoomContext';
import * as stateActions from '../../redux/stateActions';
import PeerView from '../PeerView';
import { authenticationSelector } from '../../stores/authentication/selectors';
import { roomSelector } from '../../stores/room/selectors';
import useModal from '../../hooks/useModal';
import { Label, LeaveButton, EndButton, CloseButton, ButtonWrapper } from './styled';
import service from '../../service';

// const ConfirmEndRoomComponent = ({ roomId, close, leave, end, roomClient, role }) => {
//     const confirm = (value) => {
//         if (value === 'LEAVE') {
//             close(leave);
//         } else if (value === 'END') {
//             service
//                 .endRoom(roomId)
//                 .then((res) => {
//                     if (res.code === 200) {
//                         close(end);
//                     }
//                 })
//                 .catch(() => {
//                     close();
//                 });
//         }
//         roomClient.processUploadAudios(roomId, role);
//     };
//     return (
//         <div className={'flex flex-col justify-center items-center'}>
//             <CloseButton onClick={() => close()}>X</CloseButton>
//             <div className={'py-4px pt-16px'}>
//                 <Label level={2} type={'success'}>
//                     Do you want to leave call or end room?
//                 </Label>
//             </div>
//             <ButtonWrapper>
//                 <LeaveButton onClick={() => confirm('LEAVE')}>Leave</LeaveButton>
//                 <EndButton onClick={() => confirm('END')}>End Room</EndButton>
//             </ButtonWrapper>
//         </div>
//     );
// };

class Me extends React.Component {
    constructor(props) {
        super(props);
        this._mounted = false;
        this._rootNode = null;
    }

    render() {
        const {
            roomClient,
            connected,
            me,
            audioProducer,
            videoProducer,
            faceDetection,
            onSetStatsPeerId,
            authenticationStore,
            roomStore,
            setRoomStore,
            modalHook,
            isProvider,
            type,
            notCheckPermission,
        } = this.props;

        console.log('notCheckPermissionnotCheckPermission', notCheckPermission);

        // let micState;
        // if (!me.canSendMic) micState = 'unsupported';
        // else if (!audioProducer) micState = 'unsupported';
        // else if (!audioProducer.paused) micState = 'on';
        // else micState = 'off';

        // let webcamState;
        // if (!me.canSendWebcam) webcamState = 'unsupported';
        // else if (videoProducer && videoProducer.type !== 'share') webcamState = 'on';
        // else webcamState = 'off';

        const videoVisible = Boolean(videoProducer) && !videoProducer.paused;

        return (
            <div data-component="Me" ref={(node) => (this._rootNode = node)}>
                {/* <If condition={connected}>
                    <div className="controls">
                        <div
                            className={classnames('button', 'mic', micState)}
                            onClick={() => {
                                micState === 'on'
                                    ? roomClient.muteMic(roomStore.roomId, authenticationStore.role)
                                    : roomClient.unmuteMic();
                            }}
                        />

                        <div
                            className={classnames('button', 'webcam', webcamState, {
                                disabled: me.webcamInProgress || me.shareInProgress,
                            })}
                            onClick={() => {
                                if (webcamState === 'on') {
                                    cookiesManager.setDevices({ webcamEnabled: false });
                                    roomClient.disableWebcam();
                                } else {
                                    cookiesManager.setDevices({ webcamEnabled: true });
                                    roomClient.enableWebcam();
                                }
                            }}
                        />

                        <div
                            className={classnames('button', 'end')}
                            onClick={async () => {
                                if (['DOCTOR', 'NURSE'].includes(authenticationStore.role)) {
                                    modalHook.open({
                                        content: (
                                            <ConfirmEndRoomComponent
                                                roomId={roomStore.roomId}
                                                close={modalHook.close}
                                                roomClient={roomClient}
                                                role={authenticationStore.role}
                                                leave={() => {
                                                    roomClient.close();
                                                    setRoomStore({ leftRoom: true });
                                                }}
                                                end={() => roomClient.close()}
                                            />
                                        ),
                                        shouldCloseOnOverlayClick: true,
                                    });
                                } else {
                                    await roomClient.processUploadAudios(
                                        roomStore.roomId,
                                        authenticationStore.role
                                    );
                                    roomClient.close();
                                    setRoomStore({ leftRoom: true });
                                }
                            }}
                        >
                            <div className={classnames('inner')} />
                        </div>
                    </div>
                </If> */}

                <PeerView
                    isMe
                    peer={me}
                    audioProducerId={audioProducer ? audioProducer.id : null}
                    videoProducerId={videoProducer ? videoProducer.id : null}
                    audioRtpParameters={audioProducer ? audioProducer.rtpParameters : null}
                    videoRtpParameters={videoProducer ? videoProducer.rtpParameters : null}
                    audioTrack={audioProducer ? audioProducer.track : null}
                    videoTrack={videoProducer ? videoProducer.track : null}
                    videoVisible={videoVisible}
                    audioCodec={audioProducer ? audioProducer.codec : null}
                    videoCodec={videoProducer ? videoProducer.codec : null}
                    audioScore={audioProducer ? audioProducer.score : null}
                    videoScore={videoProducer ? videoProducer.score : null}
                    faceDetection={faceDetection}
                    onChangeDisplayName={(displayName) => {
                        roomClient.changeDisplayName(displayName);
                    }}
                    onChangeMaxSendingSpatialLayer={(spatialLayer) => {
                        roomClient.setMaxSendingSpatialLayer(spatialLayer);
                    }}
                    onStatsClick={onSetStatsPeerId}
                    type={type}
                    notCheckPermission={notCheckPermission}
                    isProvider={isProvider}
                />

                <ReactTooltip
                    type="light"
                    effect="solid"
                    delayShow={100}
                    delayHide={100}
                    delayUpdate={50}
                />
            </div>
        );
    }

    componentDidMount() {
        this._mounted = true;
        const { roomStore, authenticationStore, roomClient } = this.props;

        window.onbeforeunload = async function () {
            await roomClient.processUploadAudios(roomStore.roomId, authenticationStore.role, true);
        }.bind(this);
        setTimeout(() => {
            if (!this._mounted || this.props.me.displayNameSet) return;

            ReactTooltip.show(this._rootNode);
        }, 4000);
    }

    componentWillUnmount() {
        this._mounted = false;
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.me.displayNameSet && this.props.me.displayNameSet)
            ReactTooltip.hide(this._rootNode);
    }
}

Me.propTypes = {
    roomClient: PropTypes.any.isRequired,
    connected: PropTypes.bool.isRequired,
    me: appPropTypes.Me.isRequired,
    audioProducer: appPropTypes.Producer,
    videoProducer: appPropTypes.Producer,
    faceDetection: PropTypes.bool.isRequired,
    onSetStatsPeerId: PropTypes.func.isRequired,
    notCheckPermission: PropTypes.any,
    isProvider: PropTypes.bool,
};

const mapStateToProps = (state) => {
    const producersArray = Object.values(state.producers);
    const audioProducer = producersArray.find((producer) => producer.track.kind === 'audio');
    const videoProducer = producersArray.find((producer) => producer.track.kind === 'video');

    return {
        connected: state.room.state === 'connected',
        me: state.me,
        audioProducer: audioProducer,
        videoProducer: videoProducer,
        faceDetection: state.room.faceDetection,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onSetStatsPeerId: (peerId) => dispatch(stateActions.setRoomStatsPeerId(peerId)),
    };
};

const MeContainerWithContext = withRoomContext(connect(mapStateToProps, mapDispatchToProps)(Me));

const withHook = (Component) => {
    const WrapperComponent = (props) => {
        const authenticationStore = useRecoilValue(authenticationSelector);
        const [roomStore, setRoomStore] = useRecoilState(roomSelector);
        const modalHook = useModal();
        return (
            <Component
                {...props}
                authenticationStore={authenticationStore}
                roomStore={roomStore}
                setRoomStore={setRoomStore}
                modalHook={modalHook}
            />
        );
    };
    return WrapperComponent;
};

const MeContainer = withHook(MeContainerWithContext);

export default MeContainer;
